// extracted by mini-css-extract-plugin
export default {"painel":"styles_painel__E2lid","card":"styles_card__dMBdo"};